<template>
  <b-tabs>
    <b-tab title="Sobre">
      <b-card>
        <b-card-text>
          <b-list-group flush>
            <b-list-group-item><b>Nome</b> <br>
              {{ authUser.nome }}</b-list-group-item>
            <b-list-group-item><b>Email</b> <br>
              {{ authUser.email }}</b-list-group-item>
            <b-list-group-item><b>Nascimento</b> <br>
              {{ authUser.dataNascimento | formatDate }}
            </b-list-group-item>
            <b-list-group-item><b>CPF/CNPJ</b> <br>
              {{ authUser.cpfCnpj | cpfCnpj }}</b-list-group-item>
            <b-list-group-item><b>Documento</b> <br>
              {{ authUser.documento }}</b-list-group-item>
          </b-list-group>
        </b-card-text>
      </b-card>
    </b-tab>
    <b-tab
      v-if="authUser && authUser.mandato"
      title="Mandato"
    >
      <b-card>
        <b-card-text>
          <b-list-group flush>
            <b-list-group-item>
              <b>Atribuição</b> <br>
              {{ authUser.mandato.atribuicao }}
            </b-list-group-item>
            <b-list-group-item>
              <b>Status</b> <br>
              <b-badge :variant="authUser.mandato.ativo ? 'success' : 'secondary'">
                {{ authUser.mandato.ativo ? 'Ativo' : 'Inativo' }}
              </b-badge>
            </b-list-group-item>
            <b-list-group-item v-if="authUser.mandato.sindico !== undefined">
              <b>Síndico</b> <br>
              {{ authUser.mandato.sindico ? 'Sim' : 'Não' }}
            </b-list-group-item>
            <b-list-group-item v-if="authUser.mandato.assinaPrestacaoContas !== undefined">
              <b>Assina Prestação de Contas</b> <br>
              {{ authUser.mandato.assinaPrestacaoContas ? 'Sim' : 'Não' }}
            </b-list-group-item>
          </b-list-group>
        </b-card-text>
      </b-card>
    </b-tab>
    <b-tab title="Relacionamentos">
      <b-card>
        <b-list-group class="mt-3 rounded-0">
          <b-list-group-item
            v-for="item in minhasEmpresas"
            :key="item.id"
            flush
          >
            {{ item.razaoSocial }}
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-tab>
    <b-tab title="Assinatura">
      <b-card>
        <b-card-text>
          <b-row align-v="center">
            <b-col><assinatura-pad
                     :anexo="assinatura"
                     @assinado="onAssinado"
                   />
              <b-button
                icon="download-icon"
                variant="primary"
                type="button"
                :disabled="loading"
                @click="onAssinar"
              >
                <b-spinner
                  v-if="loading"
                  small
                />
                Salvar Assinatura
              </b-button>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
    </b-tab>
  </b-tabs>
</template>

<script>
import { VBToggle, BListGroup, BListGroupItem } from 'bootstrap-vue'
import AssinaturaPad from '../commons/AssinaturaPad.vue'
import dataURItoBlob from '@/libs/img'
import UploadAPI from '@/api/upload'
import MinhaContaAPI from '@/api/minhaconta'

export default {
  components: {
    BListGroup,
    BListGroupItem,
    AssinaturaPad,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  data() {
    return {
      url: null,
      authUser: null,
      assinaturaBase64: null,
      loading: false,
    }
  },
  computed: {
    minhasEmpresas() {
      return this.$store.state.conta.minhasEmpresas
    },
    assinatura() {
      return this.$store.getters['minhaconta/getAssinatura']()
    },
  },
  async created() {
    this.authUser = this.$store.getters['auth/authUser']()
    this.$store.dispatch('conta/fetchMinhasEmpresas')
    this.$store.dispatch('minhaconta/init')
  },
  methods: {
    showError(err) {
      this.$toast.error(err.response ? err.response.data.error : err)
    },
    onAssinado(assinaturaBase64) {
      this.assinaturaBase64 = assinaturaBase64
    },
    async onAssinar() {
      this.loading = true

      if (this.assinaturaBase64) {
        const blob = dataURItoBlob(this.assinaturaBase64)
        const fd = new FormData(document.forms[0])
        fd.append('arquivos', blob, 'assinatura.png')
        const upload = await UploadAPI.upload(fd)
        const anexos = upload.data
        if (anexos.length === 1) {
          try {
            if (this.assinatura && this.assinatura.id) {
              await MinhaContaAPI.deleteAnexo(this.assinatura.id)
            }
            const anexo = anexos[0]
            anexo.tipoAnexo = 'ASSINATURA'
            await MinhaContaAPI.createAnexo(anexo)
            this.$store.dispatch('minhaconta/fetchAnexos')
            this.$toast.success('Assinatura atualizada com sucesso')
          } catch (err) {
            this.showError(err)
          }
        }
      }
      this.loading = false
    },
  },
}
</script>

<style>
.avoid-break-word {
  word-break: initial;
}
</style>
